import React, { useState } from 'react'

import { BiShapeSquare } from "react-icons/bi";
import { GoPasskeyFill } from "react-icons/go";
import { TbRewindForward50 } from "react-icons/tb";
import { TbRewindBackward50 } from "react-icons/tb";
import { MdCurrencyRupee } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { SiKfc } from "react-icons/si";

import heroImg from '../../../../assets/bhutani/Food/foodCourtHero.png'
import inner1 from '../../../../assets/bhutani/Food/foodCourt-1.jpg'
import inner2 from '../../../../assets/bhutani/Food/foodCourt-2.webp'
import inner3 from '../../../../assets/bhutani/Food/foodCourt-3.webp'
import inner4 from '../../../../assets/bhutani/Food/foodCourt-4.jpg'
import inner5 from '../../../../assets/bhutani/Food/foodCourt-5.png'

import { ImageModal } from '../../../common/ImageModal';
import { ConnectForm } from '../../../common/ConnectForm';

const FoodCourt = () => {
    const [openImgModal, setOpenImgModal] = useState(false)
    const innerImgs = [inner1, inner2, inner3, inner4, inner5]



    const points = [
        {
            icon: SiKfc,
            title: 'Brands - KFC, Burger King, Pizza Hut, Dominos etc',
        },
        {
            icon: BiShapeSquare,
            title: 'Total Area 50000sqf',
        },
        {
            icon: IoMdCheckmarkCircleOutline,
            title: 'SIZE - 200 sqft',
        },
        {
            icon: GoPasskeyFill,
            title: 'Leases Guarantee- rs.175 per sqf',
        },
        {
            icon: MdCurrencyRupee,
            title: 'Payment Plan- 50:50',
        },
        {
            icon: TbRewindForward50,
            title: ' 50% on Booking',
        },
        {
            icon: TbRewindBackward50,
            title: '50% in 18 Months',
        },
    ]


    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[500px] bg-cover bg-center mb-5"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div class="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify">The Luxury Food Court at Bhutani City Center 32 in Noida Sector 32 is a culinary haven that promises an
                                unforgettable dining experience. Located conveniently within the mall, this food court offers a diverse range of
                                cuisines, from local street food delights to international gourmet experiences.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> With modern design, vibrant decor, and ample seating, the food court creates a welcoming atmosphere for family
                                outings, casual meetups, or quick bites. Whether you're craving spicy Indian curries, cheesy Italian pizzas, or exotic
                                Asian dishes, the food court has it all under one roof.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> The food court is designed to cater to food lovers of all ages, providing a harmonious blend of sophistication, flavor,
                                and ambiance. It's the perfect spot to indulge in a variety of cuisines crafted by renowned chefs, making every meal a
                                delightful experience. </p>
                        </div>

                        <div className="max-w-4xl mx-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {points.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
                                    >
                                        {React.createElement(point.icon, {
                                            size: 24,
                                            color: "green",
                                            className: "w-6 h-6 mr-3",
                                        })}
                                        <span className="text-gray-700 font-medium">{point.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            {openImgModal && (
                <ImageModal images={innerImgs} openImg={openImgModal} />
            )}
            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {innerImgs.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => setOpenImgModal(true)}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img src={data} alt="Bhutani"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>

        </div>
    )
}

export default FoodCourt;